export interface UnreadWhatsappConversationsNotification {
  conversationCount: number;
}
export const defaultNotification: UnreadWhatsappConversationsNotification = {
  conversationCount: 0,
};
